import { isEmpty, cloneDeep } from 'lodash'
import { CONSTANTS } from '../factories'
import { AffiliateModule, ApplicationModule, AuthModule } from '../store'
import Address from '../types/application/Address'
import Employment from '../types/application/Employment'
import LoanApplication from '../types/application/LoanApplication'
import Utm from '../types/application/Utm'
import Vehicle from '../types/application/Vehicle'
import AddressDto from '../types/dto/addressDto'
import EmploymentDto from '../types/dto/employmentDto'
import { ContactNumberMapperService } from './mappers'
import DefaultValue from "@/const/default_value";

function removeEmpty (obj: any) {
  Object.keys(obj).forEach((key) => (obj[key] === null) && delete obj[key])
}

export default {
  map () {
    const result = {} as LoanApplication

    if (ApplicationModule.form) {
      if (ApplicationModule.form.referral && ApplicationModule.form.referral.referralId) { result.referralId = ApplicationModule.form.referral.referralId }

      if (ApplicationModule.form.referral && ApplicationModule.form.referral.riskBand) { result.riskBand = ApplicationModule.form.referral.riskBand }

			if (ApplicationModule.clickId) result.clickId = ApplicationModule.clickId;
      if (ApplicationModule.quoteId) result.quoteId = ApplicationModule.quoteId;

      let loanAmount = ApplicationModule.form.loanAmount

      if (!loanAmount) { loanAmount = DefaultValue.LoanAmount }

      result.loanAmount = Number(loanAmount)
      result.firstName = ApplicationModule.form.firstName
      result.lastName = ApplicationModule.form.lastName
      result.maritalStatusId = ApplicationModule.form.maritalStatus.id ?? undefined
      result.email = ApplicationModule.form.email
      result.contactNumber = ContactNumberMapperService.map(ApplicationModule.form.contactNumber!)!
      result.netMonthlyIncome
      if (ApplicationModule.form.dateOfBirth) {
        result.dateOfBirth = new Date(ApplicationModule.form.dateOfBirth)
      }

      result.titleId = ApplicationModule.form.title.id ?? undefined
      result.vehicleTypeId = ApplicationModule.form.vehicleType.id ?? undefined
      result.drivingLicenceTypeId = ApplicationModule.form.drivingLicence.id ?? undefined

      result.addresses = []

      if (ApplicationModule.form.addresses && ApplicationModule.form.addresses.length > 0) {
        let addressLevel = 0

        const addresses = cloneDeep(ApplicationModule.form.addresses) as AddressDto[]

        addresses.forEach(item => {
          removeEmpty(item)

          if (isEmpty(item) === false) {
            const address = {} as Address

            address.addressLevel = addressLevel
            address.subBuilding = item.subBuilding ? item.subBuilding : ''
            address.buildingName = item.buildingName ? item.buildingName : ''
            address.buildingNumber = item.buildingNumber ? item.buildingNumber : ''
            address.locality = item.locality ? item.locality : ''
            address.town = item.town ? item.town : ''
            address.postcode = item.postcode ? item.postcode : ''
            address.yearsAtAddress = (item.yearsAtAddress && item.yearsAtAddress > 10) ? 10 : item.yearsAtAddress
            address.monthsAtAddress = (item.monthsAtAddress && item.monthsAtAddress > 11) ? 11 : item.monthsAtAddress
            address.residentialStatusId = item.residentialStatusLookup.id ?? undefined
            address.county = item.county ? item.county : ''
            address.street = item.street ? item.street : ''

            address.flatNumber = (!item.flatNumber || item.flatNumber.length === 0) ? item.subBuilding : item.flatNumber
            address.subBuilding = (!item.subBuilding || item.subBuilding.length === 0) ? item.flatNumber : item.subBuilding

            address.flatNumber = address.flatNumber ? address.flatNumber : ''
            address.subBuilding = address.subBuilding ? address.subBuilding : ''

            if (address.yearsAtAddress === undefined || address.yearsAtAddress === null) { address.yearsAtAddress = 0 }

            if (address.monthsAtAddress === undefined || address.monthsAtAddress === null) { address.monthsAtAddress = 0 }

						result.addresses!.push(address)
						addressLevel++
          }
        })
      }

      result.employments = []

      if (ApplicationModule.form.employments && ApplicationModule.form.employments.length > 0) {
        let employmentLevel = 0

        const employments = cloneDeep(ApplicationModule.form.employments) as EmploymentDto[]

        employments.forEach(item => {
          removeEmpty(item)

          if (isEmpty(item) === false) {
            const employment = {} as Employment

            employment.employmentLevel = employmentLevel
            employment.statusId = item.employmentStatusLookup.id ?? undefined
            employment.yearsAtEmployer = (item.yearsAtEmployer && Number(item.yearsAtEmployer) > 10) ? 10 : item.yearsAtEmployer ? Number(item.yearsAtEmployer!) : undefined
            employment.monthsAtEmployer = (item.monthsAtEmployer && Number(item.monthsAtEmployer) > 11) ? 11 : item.monthsAtEmployer ? Number(item.monthsAtEmployer) : undefined
            employment.occupation = item.occupation
            employment.employerName = item.employerName
            employment.employerTown = item.employerTown

            if (employment.yearsAtEmployer === undefined || employment.yearsAtEmployer === null) { employment.yearsAtEmployer = 0 }

            if (employment.monthsAtEmployer === undefined || employment.monthsAtEmployer === null) { employment.monthsAtEmployer = 0 }

						result.employments!.push(employment)
						employmentLevel++
          }
        })
      }

      if (ApplicationModule.form.netMonthlyIncome && ApplicationModule.form.netMonthlyIncome > 0) { result.netMonthlyIncome = Number(ApplicationModule.form.netMonthlyIncome) }

      if (ApplicationModule.form.agreedToTermsAndConditions && ApplicationModule.form.agreedToTermsAndConditions === true) { result.agreedTermsAndConditions = true }

      result.isPromoEmail = ApplicationModule.form.isPromoEmail
      result.isPromoSms = ApplicationModule.form.isPromoSms
      result.isPromoWhatsApp = ApplicationModule.form.isPromoWhatsApp
      result.isPromoTelephone = ApplicationModule.form.isPromoTelephone
      result.isShareInfo = ApplicationModule.form.isPromoShareInfo

      result.utmParameters = {} as Utm

      result.utmParameters.source = (ApplicationModule.utmParameters && ApplicationModule.utmParameters.source) ?? null,
      result.utmParameters.medium = (ApplicationModule.utmParameters && ApplicationModule.utmParameters.medium) ?? null,
      result.utmParameters.term = (ApplicationModule.utmParameters && ApplicationModule.utmParameters.term) ?? null,
      result.utmParameters.content = (ApplicationModule.utmParameters && ApplicationModule.utmParameters.content) ?? null,
      result.utmParameters.campaign = (ApplicationModule.utmParameters && ApplicationModule.utmParameters.campaign) ?? null,
      result.utmParameters.type = (ApplicationModule.utmParameters && ApplicationModule.utmParameters.type) ?? null,
      result.utmParameters.cid = (ApplicationModule.utmParameters && Number(ApplicationModule.utmParameters.cid)) ?? null,
      result.utmParameters.sid = (ApplicationModule.utmParameters && ApplicationModule.utmParameters.sid) ?? null,
      result.utmParameters.mkwId = (ApplicationModule.utmParameters && ApplicationModule.utmParameters.mkwId) ?? null,
      result.utmParameters.agentPublicId = (ApplicationModule.utmParameters && ApplicationModule.utmParameters.agentPublicId) ?? null,
      result.utmParameters.gclid = (ApplicationModule.utmParameters && ApplicationModule.utmParameters.gclid) ?? null,
      result.utmParameters.referrerApplicationId = (ApplicationModule.utmParameters && Number(ApplicationModule.utmParameters.referrerApplicationId)) ?? null

      if (ApplicationModule.form.affiliateUserId) {
        result.affiliateUserId = ApplicationModule.form.affiliateUserId
      } else {
        result.affiliateUserId = AffiliateModule.affiliateUserID ? Number(AffiliateModule.affiliateUserID) : undefined
      }

      if (AuthModule.userAgent) { result.userAgent = AuthModule.userAgent }

      if (ApplicationModule.remoteAddress) { result.remoteAddress = ApplicationModule.remoteAddress }

      if (ApplicationModule.vehicle) {
        result.vehicle = {} as Vehicle
        result.vehicle.vehicleId = ApplicationModule.vehicle.vehicleId
        result.vehicle.vrm = ApplicationModule.vehicle.vrm
        result.vehicle.registrationYear = ApplicationModule.vehicle.registrationYear
        result.vehicle.make = ApplicationModule.vehicle.make
        result.vehicle.model = ApplicationModule.vehicle.model
        result.vehicle.price = ApplicationModule.vehicle.price
        result.vehicle.mileage = ApplicationModule.vehicle.mileage
        result.vehicle.fuelType = ApplicationModule.vehicle.fuelType
        result.vehicle.transmission = ApplicationModule.vehicle.transmission
        result.vehicle.colour = ApplicationModule.vehicle.colour
        result.vehicle.imageUrl = ApplicationModule.vehicle.imageUrl
        result.vehicle.vdpUrl = ApplicationModule.vehicle.vdpUrl
        result.vehicle.dealerInfoUrl = ApplicationModule.vehicle.dealerInfoUrl
      }

      if (ApplicationModule.deviceContextId) { result.deviceContextId = ApplicationModule.deviceContextId }

      result.urlReferrer = ApplicationModule.urlReferrer

      result.appliedDate = ApplicationModule.appliedDate!
      result.submittedBy = AuthModule.isProduction ? CONSTANTS.production.auth.clientId : CONSTANTS.replica.auth.clientId

			if (ApplicationModule.form.submissionType) {
				result.submissionTypeId = ApplicationModule.form.submissionType
			}
    }

    removeEmpty(result)

    return result
  }
}
